import type { IDiagnosticReportGetOne } from '../../interfaces/diagnosticReportGetOne';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { ReportStatus } from '../../../../common/enums/reportStatus';
import { ServiceCode } from '../../../../common/enums/serviceCode';
import { translateKey } from '../../../translate';
import { Button } from '../common';

interface IEditDiagnosticReportButtonProps {
    diagnosticReport: IDiagnosticReportGetOne;
    editDiagnosticReport?: () => Promise<void>;
    request?: IRequestGetOne;
}

export function EditDiagnosticReportButton(props: IEditDiagnosticReportButtonProps) {
    if (
        !props.diagnosticReport.authorization ||
        !props.diagnosticReport.authorization.canUpdateDiagnosticReport ||
        props.diagnosticReport.reviewStatus !== ReportStatus.draft ||
        !props.editDiagnosticReport
    ) {
        return null;
    }

    let category;
    if (
        props.request &&
        (props.request.service.code === ServiceCode.OSASC1 || props.request.service.code === ServiceCode.OSASC2)
    ) {
        category = 'contact';
    } else {
        category = props.diagnosticReport.category;
    }

    return (
        <Button
            automation="editReport"
            color="secondary"
            large
            onClick={props.editDiagnosticReport}
        >
            {translateKey('common.edit')} {translateKey('diagnosticReport.category_' + category).toLowerCase()}
        </Button>
    );
}
